export default __webpack_public_path__ + "static/media/upCaret.385f4a63.svg";